import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { SchemeItem, schemeItems } from 'sections/DigitalTools/CargoesFlow/data';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'styles/pages/DigitalTools/CargoesFlow/CargoesFlow.module.scss';

const cn = classNames.bind(styles);

const SectionScheme = (): ReactElement => {
  const { width } = useWindowSize();
  let delayValue = 0;

  const worksLists = Object.keys(schemeItems).map((key, index) => {
    return (
      <ul className={cn('scheme__list')} key={`${key}_${index}`}>
        {/* @ts-ignore */}
        {schemeItems[key].map((item: SchemeItem) => {
          delayValue += 0.05;
          return (
            <li className={cn('scheme__list-item')} key={item.id}>
              <div className={cn('scheme__list-item-side-icon-box')}>
                <img
                  className={cn('scheme__list-item-side-icon')}
                  src={item.sideIconPath}
                  alt={item.sideIconAlt}
                />
              </div>
              {item.mainIconPath !== '' ? (
                <div className={cn('scheme__list-item-icon-box')}>
                  <img className={cn('scheme__list-item-icon')} src={item.mainIconPath} alt={item.mainIconAlt} />
                </div>
              ) : (
                <></>
              )}
              <p className={cn('scheme__list-item-text')}>{item.name}</p>
            </li>
          );
        })}
      </ul>
    );
  });

  return (
    <section className={cn('scheme')}>
      <div className={cn('container')}>
        <img
          className={cn('scheme__image-line')}
          src={
            width <= 576
              ? '/images/pages/DigitalTools/CargoesFlow/scheme-icon-line-mobile.svg'
              : '/images/pages/DigitalTools/CargoesFlow/scheme-icon-line.svg'
          }
          alt="Design line"
        />
        <h2 className={cn('scheme__title')}>How it works?</h2>
        <div className={cn('scheme__lists')}>{worksLists}</div>
      </div>
    </section>
  );
};

export default SectionScheme;
